module.exports = __webpack_public_path__ + "assets/img/micronet-member-hover.578ab9b1.png";